import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

// List Share Certificates for a society
export const listShareCertificatesReq = (action) => {
    const searchQuery = action?.data || {};
    const { societyId } = searchQuery;
    const url = apiEndpoints.LIST_SHARE_CERTIFICATES_API.replace(':societyId', societyId);

    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };
    if (searchQuery.status) params.status = searchQuery.status;
    if (searchQuery.flatId) params.flatId = searchQuery.flatId;
    if (searchQuery.entityId) params.entityId = searchQuery.entityId;
    return axiosInstance.get(url, { params });
}

// Get Share Certificate Detail
export const getShareCertificateReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_SHARE_CERTIFICATE_API.replace(':id', id);
    return axiosInstance.get(url);
}

// Mark or Release Lien on a Share Certificate
export const setShareCertificateLienReq = (action) => {
    const payload = { ...(action?.data || {}) };
    const { id } = payload;
    delete payload.id;
    delete payload.onSuccess;

    const url = apiEndpoints.SET_SHARE_CERTIFICATE_LIEN_API.replace(':id', id);
    return axiosInstance.patch(url, payload);
}
